<template>
  <div class="w-full max-w-md p-8 bg-white shadow-md flex flex-col gap-6">
    <template v-if="!emailSent">
      <h2 class="self-start text-xl font-semibold text-gray-800">{{ t('login.forgotPassword') }}</h2>
      <p class="text-gray-700 text-base w-full text-justify">
        {{ t('forgotPassword.description') }}
      </p>
      <div v-if="errorMessage" class="text-red-600 text-sm mb-2 text-center">{{ errorMessage }}</div>
      <div class="flex flex-col gap-1 w-full">
        <label for="email" class="self-start text-base text-gray-700">{{ t('login.email') }}</label>
        <input
          id="email"
          v-model="email"
          type="email"
          autocomplete="username"
          class="border bg-white text-gray-700 border-gray-300 rounded-lg px-3 py-4 outline-none focus:border-gray-500 transition w-full"
          @keyup.enter="sendResetLink"
        />
      </div>
      <div class="flex flex-col gap-3 w-full mt-2 mb-2">
        <a
          class="cursor-pointer font-semibold text-gray-700 text-sm bg-[#fff] border-0 shadow-none hover:underline focus:outline-none mx-auto px-0 py-0"
          @click="goBack"
        >
          {{ t('button.goBack') }}
      </a>
        <BaseButton size="custom"
          type="button"
          class="!bg-[#7a2323] text-base h-11 w-full !rounded"
          @click="sendResetLink"
        >
          {{ t('forgotPassword.sendResetLink') }}
        </BaseButton>
      </div>
      <div class="text-center text-sm mt-2 text-gray-700">
        {{ t('forgot.donthaveaccount') }}
        <a href="javascript:void(0)" @click="redirectToSignup" class="font-semibold text-gray-800 hover:underline font-bold">{{ t('forgot.register') }}</a>
      </div>
    </template>
    <template v-else>
      <h2 class="self-start text-xl font-semibold text-gray-800">{{ t('forgotPassword.title') }}</h2>
      <p class="text-gray-800 text-base w-full text-center">
        {{ t('forgotPassword.emailSentTitle') }}
      </p>
      <p class="text-gray-700 text-base w-full text-center">
        {{ t('forgotPassword.emailSentDescription') }}
      </p>
      <BaseButton size="custom"
        type="button"
        class="!bg-[#7a2323] hover:!bg-[#762123] !font-bold h-11 w-full !rounded"
        @click="goBack">
        {{ $t("login.button") }}
      </BaseButton>
    </template>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import { useRouter } from "vue-router";
import authenticationService from "@/services/authenticationService";
import { useI18n } from 'vue-i18n';
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';
const errorMessage = ref("");
const { t } = useI18n();
const emit = defineEmits(['show-login']);
const email = ref("");
const emailSent = ref(false);

const { locale } = useI18n();
function goBack() {
  emit('show-login');
}

async function sendResetLink() {
  if (!email.value) {
    errorMessage.value = t('validation.required');
    return;
  }
  // Email format validation
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(email.value)) {
    errorMessage.value = t('validation.email');
    return;
  }
  const res = await authenticationService.forgotPassword(email.value);
  if (res.success) {
    emailSent.value = true;
  } else {
    errorMessage.value = res.error || t('status.error');
  }
}

function redirectToSignup() {
  window.open(`/register/?language=${locale.value}`, "_self");
}
</script>

<style scoped>
.text-white {
  color: #fff;
}
</style>
